/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_SaveInputs */

const cs_integrations_gads_save = /** @type {(inputs: Integrations_Gads_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit Google Ads`)
};

const en_integrations_gads_save = /** @type {(inputs: Integrations_Gads_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Google Ads`)
};

/**
* | output |
* | --- |
* | "Save Google Ads" |
*
* @param {Integrations_Gads_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_save = /** @type {((inputs?: Integrations_Gads_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_save(inputs)
	return cs_integrations_gads_save(inputs)
});